import React from 'react';
import { FaGithub, FaFacebookF, FaLinkedinIn, FaTwitter, FaDev } from 'react-icons/fa';
import { SiHashnode } from 'react-icons/si';
import { trackSocialClick } from '../../utils/analytics';

const HeaderSocials = () => {
    return (
        <div className='home__socials'>
            <a href='https://github.com/Hiteshshingala' className='home__social-link' target='_blank' rel='noreferrer'
               onClick={() => trackSocialClick('GitHub')}>
                <FaGithub />
            </a>

            {/* <a href='https://hashnode.com/@gregsithole' className='home__social-link' target='_blank' rel='noreferrer'>
                <SiHashnode />
            </a>

            <a href='https://dev.to/gregsithole' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaDev />
            </a> */}

            <a href='https://www.linkedin.com/in/hiteshshingala' className='home__social-link' target='_blank' rel='noreferrer'
               onClick={() => trackSocialClick('LinkedIn')}>
                <FaLinkedinIn />
            </a>

            {/* <a href='https://wwww.facebook.com/Greg.Sithole' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaFacebookF />
            </a> */}

            <a href='https://twitter.com/Hitesh1583' className='home__social-link' target='__blank' rel='noreferrer'
               onClick={() => trackSocialClick('Twitter')}>
                <FaTwitter />
            </a>
        </div>
    );
};

export default HeaderSocials;
